import { makeVar, useReactiveVar } from '@apollo/client';

import { getStoredFilters } from '../utils';
import { Filters } from '../types';

export const activeFiltersVar = makeVar<Filters>(getStoredFilters());
export const useActiveFilters = () => useReactiveVar(activeFiltersVar);
